interface searchWallpapersTypes {
  title?: string;
  category?: string;
  duration?: string;
  sort?: string;
  page: number;
  limit: number;
}

async function searchWallpapers(params: searchWallpapersTypes) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const baseUrl = new URL(`${serverURL}/api/wallpapers`);

  const searchParams = new URLSearchParams({
    page: params.page.toString(),
    limit: params.limit.toString(),
  });

  if (params.title) searchParams.set("title", params.title);
  if (params.category) searchParams.set("category", params.category);
  if (params.duration) searchParams.set("duration", params.duration);
  if (params.sort) searchParams.set("sort", params.sort);

  baseUrl.search = searchParams.toString();

  try {
    const res = await fetch(baseUrl.toString(), { credentials: "include" });
    return await res.json();
  } catch (error) {
    return null;
  }
}

export default searchWallpapers;
